<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">创建时间：</span>
					<el-date-picker v-model="search_date" :editable="false" placeholder="创建时间" type="date"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</div>

				<div class="b_item">
					<span class="b_label">卡片选择：</span>
					<el-select v-model="search_id" class="b_inp" placeholder="请选择" :clearable="false">
						<el-option :value="null" label="全部"></el-option>
						<el-option v-for="v in allCard" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>

				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->

			<!-- action -->
			<div style="margin-top: 20px;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->

			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="id" label="编号">
					</el-table-column>
					<el-table-column prop="name" label="卡片名称">
					</el-table-column>
					<el-table-column prop="createDate" label="创建时间">
					</el-table-column>
					<el-table-column prop="operator" label="操作人">
					</el-table-column>
					<el-table-column prop="amount" label="卡片张数" width="400">
					</el-table-column>
					<el-table-column label="操作" width="150">
						<!-- slot-scope="scope" -->
						<template slot-scope="scope">
							<el-button @click="output(scope.row)">导出</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, prev, pager, next, jumper" next-text="下一页" :total="total"
						:current-page="currentPage" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>

		<add v-model="add_display" @onSuccess="addSuccess"></add>
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Api from '../../../../../api/index.js';
	import {
		mapState
	} from 'vuex';
	import BaseMethods from '../../../../../assets/js/base.js';

	export default {
		mounted() {
			this.search();
		},
		data() {
			return {
				loading: false,

				search_date: '',
				search_id: null,

				tableData: [],
				total: 0,
				currentPage: 1,

				add_display: false
			}
		},
		computed: {
			...mapState([
				'allCard'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.search();
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 代理商设置成功
			addSuccess() {
				this.search();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.search();
				}
			},
			// 点击导出
			output(data) {
				const that = this;
				that.loading = true;
				
				Api.exportCardGenerate(data.id).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '卡片名称,卡片时效,卡号,激活码,\n';
						res.data.data.forEach(v => {
							str += `${ v.cardName }`;
							str += ',';
							str += `${ v.cardTime }`;
							str += ',';
							str += `${ v.cardNo }`;
							str += ',';
							str += `${ v.cardPassword }`;
							str += ',';
							str += '\t,';
							str += '\n';
							// str += `${ v.cardTime90 },`;
							// str += `${ v.cardNo90 }\t,`;
							// str += `${ v.cardPassword90 }\t,`;

							// str += `${ v.cardTime180 },`;
							// str += `${ v.cardNo180 }\t,`;
							// str += `${ v.cardPassword180 }\t,`;

							// str += `${ v.cardTime365 },`;
							// str += `${ v.cardNo365 }\t,`;
							// str += `${ v.cardPassword365 }\t,\n`;
						});
						BaseMethods.outputExcel(str, '卡片生成');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},

			/************************ @Function *******************************/
			// 查询
			search() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					productId: that.search_id,
					start: that.search_date
				};
				Api.findCardGenerateByPageAndCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								name: that.getCardNameById(v.productId),
								createDate: v.createTs,
								operator: v.adminUserName,
								amount: `15天：${ v.days15Count }张；`
								// amount: `15天：${ v.days15Count }张；30天：${ v.days30Count }张；90天：${ v.days90Count }张；180天：${ v.days180Count }张；365天：${ v.days365Count }张`
							});
						});
						that.total = res.data.data.total;
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 通过id获取卡片名称
			getCardNameById(id) {
				let name = '';
				this.allCard.forEach(v => {
					v.id == id && (name = v.name);
				});
				return name;
			}
		},
		components: {
			Add
		}
	}
</script>

<style scoped>
</style>